import { ENVIRONMENT_DEV, ENVIRONMENT_PROD, ENVIRONMENT_UAT, } from '../environments';
const API_ENVIRONMENT_DEV = '-dev';
const API_ENVIRONMENT_UAT = '-uat';
const API_ENVIRONMENT_PROD = '';
const API_ENVIRONMENT = {
    [ENVIRONMENT_DEV]: API_ENVIRONMENT_DEV,
    [ENVIRONMENT_UAT]: API_ENVIRONMENT_UAT,
    [ENVIRONMENT_PROD]: API_ENVIRONMENT_PROD,
};
// 2025-04-04 14:48:27 - Marco Borean
// Per ora usiamo questo endpoint, in futuro potremmo recuperare da una cdn più generica
export const API_LENSES_TRANSITIONS_URL = `https://vmmv${API_ENVIRONMENT[__MV_ENVIRONMENT__]}.luxottica.com/assets/transitions/transitions-swatches.json`;
